/* eslint-disable no-unused-vars */
export enum TextSizes {
  DEFAULT = 'm',
  SMALL = 's',
  EXTRASMALL = 'xs',
  CARD = 'card',
}
